import { Calendar as CalendarIcon } from '@tamagui/lucide-icons';
import { Calendar } from '@unistocks/features/dashboard/components/dashboard-data/date/calendar';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/date/query-filter';
import {
  CalendarSettingsContentStep,
  CalendarSettingsLayoutStep,
  calendarSchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/date/settings';
import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';
import { ensurePortfolioFilter } from '@unistocks/features/dashboard/utils';

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: Calendar,
  settingsSteps: [CalendarSettingsContentStep, CalendarSettingsLayoutStep],
  schemaFactory: calendarSchemaFactory,
  normalizeSettings: ensurePortfolioFilter,
  defaults: setValue => {
    setValue('sections', []);
    setValue('assetTypes', []);
  },
  queryFilter: queryFilter,
  icon: CalendarIcon
};
